import { lazy, Suspense } from "react";
import { EmptyState as EmptyStateIcon } from "../../icons/EmptyState";
import { cn } from "../../utils";
import { EmptyStateProps, EmptyStateVariant } from "./types";

const LazyNoResults = lazy(() =>
  import("../../icons/EmptyStateNoResults").then(m => ({
    default: m.EmptyStateNoResults,
  })),
);

const LazyFiltered = lazy(() =>
  import("../../icons/EmptyStateFiltered").then(m => ({
    default: m.EmptyStateFiltered,
  })),
);

const VARIANT_ILLUSTRATION: Record<EmptyStateVariant, React.ElementType> = {
  default: EmptyStateIcon,
  "no-results": LazyNoResults,
  filtered: LazyFiltered,
};

export const EmptyState = ({
  variant = "default",
  title,
  description,
  action,
  secondaryAction,
}: EmptyStateProps) => {
  const Illustration =
    VARIANT_ILLUSTRATION[variant] ?? VARIANT_ILLUSTRATION.default;

  return (
    <div className="flex flex-col items-center justify-center size-full p-14">
      <Suspense>
        <Illustration className="mb-6 w-38.25" />
      </Suspense>
      <p className="mb-2 text-h5 font-normal antialiased text-text-general-neutral-strongest w-full text-center">
        {title}
      </p>
      <p
        className={cn(
          "text-sm font-normal antialiased text-text-general-neutral-mid text-center w-full",
          action && "mb-4",
        )}
      >
        {description}
      </p>
      {action}
      {secondaryAction && <div className="mt-2">{secondaryAction}</div>}
    </div>
  );
};
